(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/fractiongames/assets/redux/games-provider.js') >= 0) return;  svs.modules.push('/components/numbergames/fractiongames/assets/redux/games-provider.js');
"use strict";


const store = svs.numbergames.fractiongames.redux.store;
const FractionGamesProvider = _ref => {
  let {
    children
  } = _ref;
  return React.createElement(ReactRedux.Provider, {
    store: store
  }, children);
};
svs.numbergames.fractiongames.redux.FractionGamesProvider = FractionGamesProvider;

 })(window);